//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "alliance_store",
    data() {
        return {
            title: "附近门店",
            page: 1,
            per_page: 5,
            longitude: "", //经度
            latitude: "", //纬度
            address: [],
            url: window.location.href, //当前地址
            addComp: null,
        };
    },
    created() {
        if (sessionStorage.getItem("token") == null) {
            this.get_token(this.url);
        } else {
            this.get_conf();
        }
    },
    methods: {
        //获取当前直线距离
        getDistance(distance) {
            if (distance < 1000) {
                return distance + "m";
            } else if (1000 < distance < 10000) {
                return (distance / 1000).toFixed("1") + "km";
            } else if (distance > 10000) {
                return parseInt(distance / 1000) + "km";
            }
        },

        //获取token
        get_token(url) {
            var self = this;
            this.$EpetJs.Common.approve(url,function() {
                self.get_conf();
                self.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
            }); //生成token
        },
        get_conf() {
            //微信js授权config
            var self = this;
            this.$EpetJs.Common.get_conf(this.url, function(res) {
                self.$wx.config(res);
                self.$wx.error(function(res) {
                    alert("出错了：" + res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
                });
            });
            this.$wx.ready(function() {
                setTimeout(function(){
                  self.get_address();
                },500) 
            });
        },

        
        //获取当前位置
        get_address() {
            var self = this;
            this.$wx.getLocation({
                type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: function(res) {
                    self.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                    self.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180
                    self.getMapName(res.latitude, res.longitude);
                    self.page = 1;
                    self.address = [];
                    self.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
                },
                fail: function() {
                    self.addComp = "error";
                },
                cancel: function(res) {
                    alert("用户拒绝授权获取地理位置");
                }
            });
        },
        //经纬度转地址
        getMapName(latitude, longitude) {
            var _this = this;
            setTimeout(function() {
                var map = new BMap.Map("allmap");
                var point = new BMap.Point(longitude, latitude);
                var gc = new BMap.Geocoder();
                gc.getLocation(point, function(rs) {
                    _this.addComp = rs.addressComponents;
                    
                });
            }, 500);
        },
        infiniteHandler($state) {
            if(sessionStorage.getItem("token") == null){
                return;
            }
            this.get_store($state);
        },
        //获取附近门店
        get_store($state) {
            var self = this;
            this.$EpetJs.Common.get(
                "public/shops/nearby?page=" +this.page +"&per_page=" +this.per_page +"&longitude=" +this.longitude +"&latitude=" +this.latitude,{}
            ).then(({ data }) => {
                if (data.status_code == "200") {
                    if (data.data.length > 0) {
                        self.address = self.address.concat(data.data);
                        self.page += 1;
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                }
            });
        },
        go_map(info) {
            var self = this;
            this.$wx.openLocation({
                latitude: Number(info.shop_location_lat), // 纬度，浮点数，范围为90 ~ -90
                longitude: Number(info.shop_location_lng), // 经度，浮点数，范围为180 ~ -180。
                name: info.shop_name, // 位置名
                address: info.shop_address, // 地址详情说明
                scale: 1, // 地图缩放级别,整形值,范围从1~28。默认为最大
                infoUrl: "" // 在查看位置界面底部显示的超链接,可点击跳转
            });
            self.$wx.error(function(res) {
                alert("出错：" + res.errMsg); //这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
            });
        },
        //跳转积分专区页面
        go_exchange() {
            this.$router.push({ name: "alliance_exchange" });
        }
    }
};
